import {
  B1,
  COLOR_MAP,
  CustomModal,
  getTranslatedText,
  Icon
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  ButtonGroup,
  TextContainer,
  Modal
} from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';

import { FileImport } from '@styled-icons/fa-solid';
import { Delete } from '@styled-icons/material/Delete';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { DropZoneMultiple, DropZoneSingle } from './PromptModal';

const DeleteIcon = styled(Delete)`
  height: 20px;
  color: black;
  width: 20px;
`;

const EditSheet = styled.div`
  width: 600px;
  max-width: 60rem;
  min-height: 420px;
  max-height: calc(100vh - 60px);
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;

  .header {
    font-size: 20px;
    line-height: 30px;
    padding: 16px 20px;
  }
  .content {
    height: calc(100% - 110px);
  }

  .Polaris-TextContainer {
    height: 100%;
    .Polaris-DropZone {
      height: 100%;
    }
    .Polaris-Labelled--hidden {
      height: calc(100% - 40px);
    }
  }
`;

const CustomPromptModal = (props) => {
  const [file, setFile] = useState(null);
  // For multiple file upload
  const [files, setFiles] = useState([]);

  const { active, setActive, maxFiles, shouldRestrictUploadClick } = props;

  useEffect(() => {
    if (props.onFilesChange) {
      props.onFilesChange(files);
    }
  }, [files]);

  const { modalActivator, icon, link, noIcon, svg } = props;
  const handleChange = useCallback(() => {
    setActive(!active);
    setFile(null);
    setFiles([]);
  }, [active]);

  const activator = (
    <Button onClick={handleChange}>
      <DeleteIcon />
    </Button>
  );

  const submitHandler = async (inpFile) => {
    await props.handleSubmit(inpFile);
  };

  const handlePrimaryAction = useCallback(() => {
    if (file) {
      if (props.handleSubmit) {
        submitHandler(file);
      }
      handleChange();
    }
    if (files.length) {
      if (props.handleSubmit) {
        submitHandler(files);
      }
      handleChange();
    }
  });

  return (
    <CustomModal
      zIndex={props.zIndex || '525'}
      open={active}
      onClose={handleChange}
    >
      <EditSheet className="br10 fx col">
        <div className="header fx actr fx-sb divider Superops-Modal-Header">
          <B1 className="Superops-Modal-Header__Title">
            {props.title || 'Prompt Modal'}
          </B1>
          <span className="ptr" onClick={handleChange}>
            <SVGIcon name="Close" />
          </span>
        </div>
        <div className="content divider p20">
          <TextContainer>
            <p>{props.description || 'Are you sure?'}</p>
            {props.allowMultiple ? (
              <DropZoneMultiple
                files={files}
                setFiles={setFiles}
                allowMultiple={props.allowMultiple}
                acceptType={props.acceptType}
                maxFiles={maxFiles}
              />
            ) : (
              <DropZoneSingle
                file={file}
                setFile={setFile}
                acceptType={props?.acceptType}
                acceptAllType={props?.acceptAllType}
              />
            )}
          </TextContainer>
        </div>
        <div className="fx actr jend p16">
          <ButtonGroup spacing="loose">
            <Button onClick={handleChange} plainSecondary>
              {/* <FormattedMessage id="admin.mspDetails.modal.cancel" /> */}
              Cancel
            </Button>
            <Button onClick={handlePrimaryAction} primary>
              {props.btnText || 'OK'}
            </Button>
          </ButtonGroup>
        </div>
      </EditSheet>
    </CustomModal>
  );

  return (
    <Modal
      open={active}
      onClose={handleChange}
      title={props.title || 'Prompt Modal'}
      primaryAction={{
        content: props.btnText || 'OK',
        onAction: handlePrimaryAction
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: handleChange
        }
      ]}
    >
      <Modal.Section>
        <TextContainer>
          <p>{props.description || 'Are you sure?'}</p>
          {props.allowMultiple ? (
            <DropZoneMultiple
              files={files}
              setFiles={setFiles}
              allowMultiple={props.allowMultiple}
            />
          ) : (
            <DropZoneSingle file={file} setFile={setFile} />
          )}
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
};

export default injectIntl(CustomPromptModal);
